export default "__VITE_ASSET__63dbc5ea__"